<template>
    <div>
        <!--<pageheading/>-->
        <welcome-u-a-image/>
        <div class="uk-padding">
            <div class="uk-container">
                <requirements/>
            </div>
        </div>
        <additional-undergrad-information/>

        <undergrad-links/>
        <div class="uk-background-muted" uk-grid>
            <div class="uk-width-1-1@m">
                <undergrad-alumni-quote/>
            </div>
        </div>

        <!--<div class="uk-padding ">
            <div class="uk-container">
                <student-opinions/>
            </div>
        </div>-->
        <explore-undergrad-programs/>
        <incomplete-applications/>
    </div>
</template>

<script>
    import Pageheading from "../components/shared/pageheading";
    import Requirements from "../components/undergradadmission/requirements";
    import UndergradAlumniQuote from "../components/undergradadmission/undergradAlumniQuote";
    import UndergradLinks from "../components/undergradadmission/undergradLinks";
    import StudentOpinions from "../components/undergradadmission/studentOpinions";
    import WelcomeUAImage from "../components/undergradadmission/welcomeUAImg";
    import AdditionalUndergradInformation from "../components/undergradadmission/additionalUndergradInformation";
    import ExploreUndergradPrograms from "../components/undergradadmission/exploreUndergradPrograms";
    import IncompleteApplications from "../components/shared/incompleteApplications";
    export default {
        name: "UndergradAdmission",
        components: {
            IncompleteApplications,
            ExploreUndergradPrograms,
            AdditionalUndergradInformation,
            WelcomeUAImage, StudentOpinions, UndergradLinks, UndergradAlumniQuote, Requirements, Pageheading}
    }
</script>

<style scoped>

</style>
